@if (showDefaultForm) {
  <section>
    <form [formGroup]="form" novalidate (ngSubmit)="OnSubmit()">
      <header>New Attribute</header>
      <main class="first-form-margin">
        <div class="container-fluid">
          <div class="row">
            <div class="col">
              <div class="row" width="6">
                <mat-form-field>
                  <input
                    [attr.data-testid]="'attribute_name_text'"
                    formControlName="name"
                    matInput
                    [pattern]="spaceValidatorPattern"
                    placeholder="Attribute Name"
                    required
                    />
                  @if (form.controls['name'].invalid) {
                    <mat-error>
                      Please enter a Name
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="row" width="6">
                <mat-form-field>
                  <input
                    [attr.data-testid]="'attribute_tag_text'"
                    formControlName="tag"
                    matInput
                    required
                    placeholder="Attribute Tag"
                    pattern="^[A-Z_0-9]*$"
                    (focusout)="findTagExists()"
                    >
                  @if (form.controls['tag'].invalid && !form.controls['tag'].value) {
                    <mat-error>
                      Please enter a Standard Tag
                    </mat-error>
                  }
                  @if (form.controls['tag'].errors?.pattern && form.controls['tag'].value) {
                    <mat-error>
                      Please enter a Valid Standard Tag
                    </mat-error>
                  }
                  @if (form.controls['tag'].errors?.tagExists && form.controls['tag'].touched) {
                    <mat-error
                      >
                      Tag already exists! Create a new one.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="row" width="6">
                <mat-form-field>
                  <input
                    [attr.data-testid]="'json_attribute_name_text'"
                    formControlName="objectName"
                    matInput
                    placeholder="JSON Attribute Name"
                    required
                    />
                  @if (form.controls['objectName'].invalid) {
                    <mat-error>
                      Please enter a valid JSON Attribute Name
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="row" width="6">
                <mat-form-field>
                  <mat-select
                    [attr.data-testid]="'scope_select'"
                    formControlName="scope"
                    placeholder="Scope"
                    required
                    >
                    @for (scopeValues of scopes; track scopeValues) {
                      <mat-option
                        [attr.data-testid]="scopeValues.tag + '_option'"
                        [value]="scopeValues.tag"
                      >{{ scopeValues.value }}</mat-option>
                    }
                  </mat-select>
                  @if (form.controls['scope'].invalid) {
                    <mat-error>
                      Please Select a Value
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="row" width="6">
                <mat-form-field>
                  <input
                    [attr.data-testid]="'sortweight_number'"
                    formControlName="sortWeight"
                    matInput
                    placeholder="SortWeight"
                    type="number"
                    />
                </mat-form-field>
              </div>
            </div>
            <div class="col">
              <div class="row" width="6">
                <mat-form-field>
                  <mat-select
                    [attr.data-testid]="'attribute_type_select'"
                    formControlName="typetag"
                    placeholder="Attribute Type"
                    required
                    >
                    @for (attributeTypeValues of attributeTypes; track attributeTypeValues) {
                      <mat-option
                        [attr.data-testid]="attributeTypeValues.name + '_option'"
                        [value]="attributeTypeValues.tag"
                      >{{ attributeTypeValues.name }}</mat-option>
                    }
                  </mat-select>
                  @if (form.controls['typetag'].invalid) {
                    <mat-error>
                      Please Select a Value
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="row" width="6">
                @if (form.controls['typetag'].value !== 'SELECT') {
                  <fieldset
                    >
                    @switch (form.controls['typetag'].value) {
                      @case ('TEXT') {
                        <mat-form-field>
                          <input
                            [attr.data-testid]="'validation_expression'"
                            formControlName="validationExpression"
                            matInput
                            placeholder="Regex validation expression"
                            type="text"
                            />
                        </mat-form-field>
                      }
                      @case ('TEXT') {
                        <mat-form-field>
                          <input
                            [attr.data-testid]="'attribute_type_text'"
                            formControlName="defaultValue"
                            matInput
                            placeholder="Default Value"
                            type="text"
                            (focusout)="validationExpressionValidation()"
                            />
                        </mat-form-field>
                      }
                      @case ('NUM') {
                        <mat-form-field>
                          <input
                            [attr.data-testid]="'attribute_type_number'"
                            formControlName="defaultValue"
                            matInput
                            placeholder="Default Value"
                            type="number"
                            (focusout)="numberValidation()"
                            />
                          @if (form.controls['defaultValue'].invalid) {
                            <mat-error>
                              Please enter a valid value (e.g. 23.50)
                            </mat-error>
                          }
                        </mat-form-field>
                      }
                      @case ('BOOL') {
                        <mat-form-field>
                          <mat-select
                            [attr.data-testid]="'attribute_type_bool'"
                            formControlName="defaultValue"
                            placeholder="Default Value"
                            >
                            @for (requiredTypeValues of defaultRequiredTypes; track requiredTypeValues) {
                              <mat-option
                                [attr.data-testid]="requiredTypeValues.value + '_option'"
                                [value]="requiredTypeValues.tag"
                              >{{ requiredTypeValues.value }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                      @case ('DATE') {
                        <mat-form-field>
                          <input
                            [attr.data-testid]="'attribute_type_date'"
                            formControlName="defaultValue"
                            [matDatepicker]="picker"
                            matInput
                            placeholder="Choose a date"
                            required="false"
                            >
                          <mat-datepicker-toggle
                            [attr.data-testid]="'attribute_type_date_toggle'"
                            [for]="picker"
                            matSuffix
                          ></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                          @if (form.controls['defaultValue'].invalid) {
                            <mat-error>
                              Please enter a valid date
                            </mat-error>
                          }
                        </mat-form-field>
                      }
                      @case ('DATERANGE') {
                        <input
                          [attr.data-testid]="'attribute_type_date_range'"
                          autoApply="true"
                          class="form-control"
                          formControlName="defaultValue"
                          matInput
                          ngxDaterangepickerMd
                          placeholder="Default Value"
                          showCancel="true"
                          type="text"
                          (keyup)="dateRangeUpdated($event)"
                          />
                      }
                      @case ('IMAGE') {
                        <mat-form-field>
                          <input
                            [attr.data-testid]="'attribute_type_image'"
                            formControlName="defaultValue"
                            matInput
                            placeholder="Default Value"
                            type="text"
                            (focusout)="imageValidation()"
                            />
                          @if (form.controls['defaultValue'].errors?.pattern) {
                            <mat-error>
                              Please enter a valid URL
                            </mat-error>
                          }
                        </mat-form-field>
                      }
                    }
                  </fieldset>
                }
              </div>
              <div class="row" width="6">
                <mat-form-field>
                  <mat-select
                    [attr.data-testid]="'required_select'"
                    formControlName="required"
                    placeholder="Required"
                    required
                    >
                    @for (requiredTypeValues of requiredTypes; track requiredTypeValues) {
                      <mat-option
                        [attr.data-testid]="requiredTypeValues.tag + '_option'"
                        [value]="requiredTypeValues.tag"
                      >{{ requiredTypeValues.value }}</mat-option>
                    }
                  </mat-select>
                  @if (form.controls['required'].invalid) {
                    <mat-error>
                      Please Select a Value
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="row" width="6">
                <mat-form-field>
                  <mat-select
                    formControlName="localeSupport"
                    placeholder="Locale Support"
                    required
                    >
                    <mat-option [value]="false">Country</mat-option>
                    <mat-option [value]="true">Locale</mat-option>
                  </mat-select>
                  @if (form.controls['localeSupport'].invalid) {
                    <mat-error>
                      Please Select a Value
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="row" width="6">
                <mat-form-field>
                  <mat-select
                    [attr.data-testid]="'locked_select'"
                    formControlName="locked"
                    matTooltip="This will prevent deletion of the attribute"
                    placeholder="Locked"
                    required
                    >
                    @for (requiredTypeValues of requiredTypes; track requiredTypeValues) {
                      <mat-option
                        [attr.data-testid]="requiredTypeValues.value + '_option'"
                        [value]="requiredTypeValues.tag"
                      >{{ requiredTypeValues.value }}</mat-option>
                    }
                  </mat-select>
                  @if (form.controls['locked'].invalid) {
                    <mat-error>
                      Please Select a Value
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="row" width="6">
                <mat-form-field>
                  <mat-select
                    [attr.data-testid]="'attribute_group_select'"
                    formControlName="attributeGroup"
                    placeholder="Attribute Group"
                    required
                    >
                    @for (attributeGroup of attributeGroups; track attributeGroup) {
                      <mat-option
                        [attr.data-testid]="attributeGroup.id + '_option'"
                        [value]="attributeGroup.id"
                      >{{ attributeGroup.id }}</mat-option>
                    }
                  </mat-select>
                  @if (form.controls['attributeGroup'].invalid) {
                    <mat-error>
                      Please Select a Value
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="row" width="6">
                <mat-form-field>
                  <textarea
                    #message
                    [attr.data-testid]="'description_textarea'"
                    formControlName="description"
                    matInput
                    maxlength="256"
                    placeholder="Description"
                  ></textarea>
                  <mat-hint align="end">{{ message.value.length }} / 256</mat-hint>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footer>
        <button
          [attr.data-testid]="'cancel_button'"
          mat-raised-button
          matTooltip="Cancel creating Attribute"
          type="button"
          (click)="onNoClick()"
          >
          Cancel
        </button>
        @if (!(form.controls['typetag'].value === 'SELECT' || form.controls['typetag'].value === 'MULTI_SELECT')) {
          <button
            [attr.data-testid]="'save_button'"
            [disabled]="!form.valid || disableSave"
            mat-raised-button
            matTooltip="Submit Attribute"
            type="submit"
            >
            Save
          </button>
        }
        @if (form.controls['typetag'].value === 'SELECT' || form.controls['typetag'].value === 'MULTI_SELECT') {
          <button
            [attr.data-testid]="'save_button'"
            [disabled]="!form.valid"
            mat-raised-button
            matTooltip="Add select list values"
            >
            Next
          </button>
        }
      </footer>
    </form>
  </section>
}
@if (!showDefaultForm) {
  <section>
    <form [formGroup]="selectForm" novalidate>
      <header>Add {{ name | titlecase }}'s List Values</header>
      <main>
        <div>
          <div formArrayName="selectValues" class="second-form-container">
            @for (selectValue of selectValues.controls; track selectValue; let i = $index) {
              <div
                [formGroupName]="i"
                >
                <div>
                  <span>
                    @if (i == 0) {
                      <button (click)="addSelectedValues()" mat-icon-button class="icon-margin">
                        <mat-icon
                          matTooltip="Add a List Value"
                          style="font-size: 34px; color: #e5173f; padding-right: 7px;"
                          >add
                        </mat-icon>
                      </button>
                    }
                    @if (i != 0) {
                      <button
                        mat-icon-button
                        class="icon-margin"
                        (click)="removeSelectedValues(i)"
                        >
                        <mat-icon
                          style="font-size: 34px; color: #e5173f; padding-right: 7px;"
                          matTooltip="Remove this List Value"
                          >remove
                        </mat-icon>
                      </button>
                    }
                  </span>
                  <mat-form-field>
                    <input
                      formControlName="selectedValue"
                      matInput
                      placeholder="List Value"
                      required
                      (focusout)="valueExists()"
                      />
                    @if (selectValues.controls[i].get('selectedValue').invalid && !selectValues.controls[i].get('selectedValue').value) {
                      <mat-error
                        >
                        Enter a List Value
                      </mat-error>
                    }
                    @if (selectValues.controls[i].get('selectedValue').errors?.duplicate) {
                      <mat-error>
                        Duplicate Value
                      </mat-error>
                    }
                  </mat-form-field>
                  <span class="icon-margin">
                    <mat-checkbox
                      formControlName="checkBox"
                      matTooltip="Make this the default value"
                      [matTooltipPosition]="'after'"
                    (change)="defaultValueExists(i)"></mat-checkbox>
                    @if (checkBoxValue) {
                      <mat-error>
                        Select a Default Value
                      </mat-error>
                    }
                  </span>
                </div>
              </div>
            }
          </div>
        </div>
        <br>
          <br>
          </main>
          <footer>
            <button
              mat-raised-button
              matTooltip="Cancel creating Attribute"
              type="button"
              (click)="showFirstForm()"
              >
              Back
            </button>
            <button
              mat-raised-button
              matTooltip="Submit Attribute"
              (click)="selectValuesSubmit()"
              >
              Save
            </button>
          </footer>
        </form>
      </section>
    }
